import React from 'react'
import { render } from 'react-dom'
import { context, gettext, notifications } from '@bikemap/js/services'
import { FavoriteInfoContainer } from './components'
import { copyToClipboard, defaultGet, getApiHeaders, logError } from '@bikemap/js/utility'
import { getRoute } from './global-state'
import { ROUTE_DETAIL_URL } from '@bikemap/js/settings'
import QRCode from 'react-qr-code'
import { onUserInteraction } from '@bikemap/js/utility/events'

const { isPrivate } = context.page()

// Translations before first JSX to not break gettext
const copyNotificationTitle = gettext('Copied to clipboard')
const copyUrlNotificationMessage = gettext('You can send or post this URL now to share the route.')
const shareText = gettext('Check out this route on Bikemap!')

/**
 * Initialize state and functionality of the main favorite button.
 */
export async function initFavoriteButton() {
    const favoriteInfoContainer = document.getElementById('favorite-info-container')
    render(<FavoriteInfoContainer route={await getRoute()} />, favoriteInfoContainer)
}

/**
 * Initialize the share button to trigger a modal offering several ways to share the route.
 */
export function initShareButtons() {
    if (isPrivate) return

    document.querySelectorAll('.js-share-button').forEach((button) => {
        button.addEventListener('click', async () => {
            const route = await getRoute()
            const url = window.location.origin + ROUTE_DETAIL_URL.replace(':routeId', route.id) +
                '?utm_source=website&utm_medium=route_detail&utm_campaign=share_route'
            if (navigator.share) {
                try {
                    await navigator.share({
                        title: route.title,
                        text: shareText,
                        url,
                    })
                } catch (error) {
                    logError('Could not share route', error)
                }
            } else {
                copyToClipboard(url)
                notifications.show({
                    title: copyNotificationTitle,
                    message: copyUrlNotificationMessage,
                    type: 'success',
                })
            }
        })
    })
}

/**
 * Make the "all images" button open the global fslightbox gallery with all route images.
 */
export function initAllImagesButton() {
    const button = document.querySelector('.js-all-images-button')

    if (button) {
        button.addEventListener('click', () => {
            window.fsLightboxInstances['route-images'].open()
        })
    }
}

/**
 * Generate and insert a QR code of a dynamic link to open the route in the app.
 */
export function initQrCode() {
    const container = document.querySelector('.js-insert-qr-code')
    if (!container.getAttribute('data-api-deep-link-path')) return

    const insertIfVisible = () => {
        if (container && container.getBoundingClientRect().width) {
            insertQrCode(container)
            window.removeEventListener('resize', insertIfVisible)
        }
    }

    window.addEventListener('resize', insertIfVisible)
    insertIfVisible()
}

/** @param {HTMLDivElement} container */
async function insertQrCode(container) {
    try {
        const res = await defaultGet(container.getAttribute('data-api-deep-link-path'), getApiHeaders())
        if (res && res.deep_link) {
            render(
                <QRCode
                    value={res.deep_link}
                    bgColor='transparent'
                    fgColor='#fff'
                />,
                container
            )
        }
        onUserInteraction(() => {
            container.parentElement.classList.add('ready')
        })
    } catch {
        container.parentElement.classList.add('hidden')
    }
}
